import { render, staticRenderFns } from "./VeiculoForm.vue?vue&type=template&id=4e8633fe"
import script from "./VeiculoForm.vue?vue&type=script&lang=js"
export * from "./VeiculoForm.vue?vue&type=script&lang=js"
import style0 from "./VeiculoForm.vue?vue&type=style&index=0&id=4e8633fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports